export default __webpack_public_path__ + "media/images/3-dogs-1-3914a5f234becd08c21dd8c4923c72d7.png";